import { createSelector } from 'reselect';

import { STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic';
import { getStakeholders } from '@/selectors/merchant/recollection';
import { getLookupData } from '@/selectors/lookupData';

const isUBO = stakeholder =>
  stakeholder.roles.includes(STAKEHOLDER_ROLES_V2.ULTIMATE_BENEFICIAL_OWNER);

const mapStakeholder = stakeholders =>
  stakeholders.map(stakeholder => ({ ...stakeholder, reactFormId: Math.random() })).filter(isUBO);

export const getLookupState = createSelector(
  getLookupData,
  getStakeholders,
  ({ stakeholders: lookupStakeholders }, stakeholders) => ({
    stakeholders: stakeholders.filter(isUBO).length
      ? stakeholders.filter(isUBO)
      : mapStakeholder(lookupStakeholders),
    isLookup:
      stakeholders.filter(isUBO).length === 0 && mapStakeholder(lookupStakeholders).length > 0,
  }),
);

export const getDefaultState = createSelector(
  getLookupData,
  getStakeholders,
  ({ stakeholders: lookupStakeholders }, stakeholders) => ({
    toggleValue:
      stakeholders.some(isUBO) || lookupStakeholders.some(isUBO)
        ? true
        : stakeholders.length > 0
        ? false
        : undefined,
  }),
);
